import { create } from 'zustand';

/**
 * Boards (Task Manager) UI state shared between the full-page TaskBoardTab and
 * the app titlebar. The boards-home filter input now lives in the titlebar
 * (see BoardsTitleBarSearch / ExtensionTitleBarActions) but filters the grid
 * rendered by TaskBoardTab, so both read/write the same `filter` here.
 *
 * `searchVisible` is set by TaskBoardTab and is true only while the boards-home
 * grid with at least one board is showing — so the titlebar hides the filter
 * when a board is open or the grid is empty.
 *
 * `scopeFilter` is the boards-home scope chip (boardsHomeFilter.js): 'all',
 * 'personal' or 'team:<teamId>'. In memory only, like `filter`.
 */
export const useTaskBoardUiStore = create((set) => ({
  filter: '',
  searchVisible: false,
  scopeFilter: 'all',
  setFilter: (filter) => set({ filter }),
  setSearchVisible: (searchVisible) => set({ searchVisible }),
  setScopeFilter: (scopeFilter) => set({ scopeFilter }),
}));
